import classcat from "classcat";
import React from "react";

import css from "./SignUpButton.module.css";

type Props = {
  title: string;
  primary?: boolean;
  onClick: () => void;
};

const SignUpButton = ({ title, primary, onClick }: Props) => {
  return (
    <button
      className={classcat([
        css.container,
        { [css.primaryButton]: primary },
        { "text-headline-2xl": primary },
        { "text-label-lg": !primary },
      ])}
      onClick={onClick}
    >
      <span className={css.title}>{title}</span>
    </button>
  );
};

export default SignUpButton;
